<template>
  <div>
    <v-layout row wrap style="height:100%;min-height:150px;" class="ml-2 event-info" align-center>
      <v-layout row wrap class=""  >
        <v-flex xs3 sm2 md1 class="event-image-flex" >
          <div style="border-radius:15px;">
            <img class="event-image" :src="event.logo || '/static/images/event-icon.png'" style="border-radius:15px;height:100px;max-height:150px;" />
          </div>
        </v-flex>

        <v-flex xs9 sm10 md6 lg7 pl-3 class="event-content">
          <h5 style="font-weight:900;cursor:pointer;font-size: 17px;"   @click.prevent="viewEvent(event)" class="secondary--text event-name"  >{{ event.title }}</h5>
          <div class="event-date date_range" >
            <b>Date:</b> {{ event.eventdate | actualDate }} {{ event.starteventtime | formatTime }} - {{ event.endeventtime | formatTime }}
          </div>
          <div class="hidden-sm-and-down">
            <b>Registration Deadline:</b> {{event.deadline || 'N/A'}}
          </div>
          <div class="hidden-sm-and-down">
            <b>Fee:</b> {{event.fee || 'N/A'}}
          </div>
          <div class="hidden-sm-and-down">
            <b>Center:</b> {{event.center || 'N/A'}}
          </div>
          <div class="hidden-sm-and-down">
            <b>Point of Contact:</b> {{event.pointofcontact || 'N/A'}}
          </div>
          <v-layout row hidden-md-and-up style="margin-left: -13px;">
            <v-flex xs4>
              <a :href="event.link" target="_blank" style="text-decoration: none;">
              <v-btn flat small style="height: auto" :style="{color: styles.general.theme_color_dark}">
                <v-layout  column style="text-transform:capitalize;">
                  <v-icon small>date_range</v-icon>
                  RSVP
                </v-layout>
              </v-btn></a>
            </v-flex>

            <v-flex xs4>
              <v-btn style="height: auto" v-if="!favorited" flat small @click.prevent="favoriteItem"  :style="{color: styles.general.theme_color_dark}">
                <v-layout column>
                  <v-icon small>favorite</v-icon>
                  Favorite
                </v-layout>
              </v-btn>
              <v-btn style="height: auto" v-else flat small @click.prevent="unfavoriteItem"  :style="{color: styles.general.theme_color_dark}">
                <v-layout column>
                  <v-icon small color="red">favorite</v-icon>
                  Favorite
                </v-layout>
              </v-btn>
            </v-flex>

            <v-flex v-on:click="seen = !seen">
              <share-button color="secondary" text="Share" size="16px" :link="link"></share-button>
            </v-flex>
          </v-layout>
        </v-flex>

        <v-flex xs3 sm4 md5 lg4 hidden-sm-and-down align-center style="display:flex">
          <v-layout row wrap align-center>
            <v-flex>
              <a :href="event.link" target="_blank" style="text-decoration: none;">
              <v-btn flat large style="height: auto" :style="{color: styles.general.theme_color_dark}">
                <v-layout  column style="text-transform:capitalize;">
                  <v-icon x-large>date_range</v-icon>
                  RSVP
                </v-layout>
              </v-btn></a>
            </v-flex>

            <v-flex>
              <v-btn style="height: auto" v-if="!favorited" flat large @click.prevent="favoriteItem"  :style="{color: styles.general.theme_color_dark}">
                <v-layout column>
                  <v-icon x-large>favorite</v-icon>
                  Favorite
                </v-layout>
              </v-btn>
              <v-btn style="height: auto" v-else flat large @click.prevent="unfavoriteItem"  :style="{color: styles.general.theme_color_dark}">
                <v-layout column>
                  <v-icon x-large color="red">favorite</v-icon>
                  Favorite
                </v-layout>
              </v-btn>
            </v-flex>

            <v-flex v-on:click="seen = !seen">
              <share-button color="secondary" text="Share" size="40px" :link="link"></share-button>
            </v-flex>
          </v-layout>
        </v-flex>

        <v-flex xs12>
          <v-divider class="mt-2"></v-divider>
        </v-flex>
      </v-layout>
    </v-layout>
  </div>
</template>
<style>
  .share_list{
    position: absolute;
    top: 0;
  }
  .layout.wrap{
    position: relative;
  }
  .share_list a{
    height:auto;
    font-size: 12px;
    color: #666;
  }
</style>
<script>
  import ShareButton from '@/components/ShareButton.vue'
  export default {
    components: {
      ShareButton
    },
    props: ['event', 'type'],
    mounted () {
        this.getFavourited
    },
    data () {
      return {
          favorited:false,
          seen:false
      }
    },
    methods: {
      copyToClipboard (link) {
          var self = this
          this.$copyText(link).then(function (e) {
              let snackbar = {
                  active: true,
                  text: 'Link Successfully Copied To Clipboard'
              }
              self.$store.dispatch('triggerSnackbar', snackbar)

              setTimeout(() => {
                  let snackbar = {
                      active: false,
                      text: ''
                  }
                  self.$store.dispatch('triggerSnackbar', snackbar)
              }, 2000)


          }, function (e) {
              let snackbar = {
                  active: true,
                  text: 'Unable To Copy Link To Clipboard'
              }
              self.$store.dispatch('triggerSnackbar', snackbar)
          })
      },
      viewEvent (event) {
        this.$emit('viewEvent', event)
      },
      showlistTrigger() {
        self = this
        self.showlist = true;
      },
      favoriteItem () {
        let favoritePayload = {
          uid: this.userDetails.uid
        }
        let self = this
        self.favorited = true
        this.$firebase.database().ref(`favorites/${this.type}/${this.userDetails.uid}/${this.event.eventKey}`).set(favoritePayload)
      },
      unfavoriteItem () {
          let self = this
        self.favorited = false
        this.$firebase.database().ref(`favorites/${this.type}/${this.userDetails.uid}/${this.event.eventKey}`).set(null)
      },
    },
    computed: {
      styles () {
        return this.$store.getters.getStyles
      },
      userDetails () {
        return this.$store.getters.getUserDetails
      },
      getFavourited () {
        var self = this
        this.$firebase.database()
        .ref(`favorites/${this.type}/${this.userDetails.uid}/${this.event.eventKey}`)
        .on('value', function(snapshot) {
            if (!snapshot.val()) {
                self.favorited = false
            } else {
                self.favorited = true
            }
        })
      },
      link () {
        var link = `https://${window.location.host}/events#id=${this.event.eventKey}`
        return link
      }
    }
  }
</script>


// WEBPACK FOOTER //
// EventTimelineComponent.vue?0918cdf0